import React, {
  useState,
} from "react";

import {
  NavLink,
  useLocation,
} from "react-router-dom";

import {
  motion,
} from "framer-motion";

import {
  Home,
  Calendar,
  Sparkles,
  Bot,
  Settings,
} from "lucide-react";

import {
  useI18n,
} from "../lib/i18n";


/* =========================================================
   GURSETU MOBILE NAVIGATION
========================================================= */

const TABS = [
  {
    key: "home",
    route: "/",
    i18n: "home",
    fallback: "Home",
    icon: Home,
  },

  {
    key: "calendar",
    route: "/calendar",
    i18n: "calendar",
    fallback: "Calendar",
    icon: Calendar,
  },

  {
    key: "simran",
    route: "/simran",
    i18n: "simran",
    fallback: "Simran",
    icon: Sparkles,
  },

  {
    key: "ai",
    route: "/ai",
    i18n: "Sahayak",
    fallback: "Sahayak",
    icon: Bot,
  },

  {
    key: "settings",
    route: "/settings",
    i18n: "settings",
    fallback: "Settings",
    icon: Settings,
  },
];


/* =========================================================
   ACTIVE ROUTE
========================================================= */

function isRouteActive(
  pathname,
  route
) {
  if (route === "/") {
    return pathname === "/";
  }

  return (
    pathname === route ||
    pathname.startsWith(
      `${route}/`
    )
  );
}


/* =========================================================
   FLOATING TAB BAR
========================================================= */

export function FloatingTabBar() {

  const location =
    useLocation();

  const {
    t,
  } = useI18n();

  const [
    pressedTab,
    setPressedTab,
  ] = useState(null);


  const handlePress = (
    key
  ) => {

    setPressedTab(key);

    window.setTimeout(
      () => {
        setPressedTab(null);
      },
      220
    );

  };


  return (

    <nav
      data-floating-tab-bar="true"

      aria-label="Main navigation"

      className="
        fixed

        left-1/2

        z-[55]

        w-[calc(100%-20px)]
        max-w-[430px]

        -translate-x-1/2

        lg:hidden
      "

      style={{
        bottom:
          "max(9px, env(safe-area-inset-bottom))",

        WebkitBackfaceVisibility:
          "hidden",

        backfaceVisibility:
          "hidden",

        transform:
          "translateX(-50%) translateZ(0)",
      }}
    >

      {/* =====================================================
          PREMIUM NAVY DOCK
      ===================================================== */}

      <div
        className="
          relative

          overflow-hidden

          rounded-[26px]

          border
          border-white/[0.075]

          bg-[#08101a]

          px-1.5
          py-1.5

          shadow-[0_15px_42px_rgba(0,0,0,0.50)]
        "
      >

        {/* ===============================================
            TOP SACRED GOLD LINE
        =============================================== */}


{/* =====================================================
    7-SECOND PREMIUM GOLD SHINE
    First sweep starts after 7 seconds.
    Medium-speed gold + pearl sweep for strong visibility.
    Repeat cycle = 1.5s sweep + 5.5s pause = 7 seconds.
===================================================== */}

<motion.div
  aria-hidden="true"
  className="
    pointer-events-none
    absolute
    inset-y-0
    -left-[46%]
    z-[3]
    w-[42%]
    -skew-x-[16deg]
  "
  initial={{
    x: "0%",
    opacity: 0,
  }}
  animate={{
    x: ["0%", "385%"],
    opacity: [0, 0.9, 1, 0.9, 0],
  }}
  transition={{
    duration: 1.5,
    delay: 7,
    repeat: Infinity,
    repeatDelay: 5.5,
    ease: [0.25, 0.1, 0.25, 1],
    times: [0, 0.16, 0.5, 0.84, 1],
  }}
  style={{
    willChange: "transform, opacity",

    background: `
      linear-gradient(
        90deg,
        rgba(255, 196, 72, 0) 0%,
        rgba(255, 196, 72, 0.10) 20%,
        rgba(255, 211, 112, 0.42) 38%,
        rgba(255, 250, 224, 0.90) 50%,
        rgba(255, 211, 112, 0.42) 62%,
        rgba(255, 196, 72, 0.10) 80%,
        rgba(255, 196, 72, 0) 100%
      )
    `,

    boxShadow:
      "0 0 18px rgba(251,191,36,0.18)",
  }}
/>


<div
  aria-hidden="true"
  className="
    pointer-events-none
    absolute
    left-1/2
    top-0
    z-[3]
    h-px
    w-[72%]
    -translate-x-1/2
    bg-gradient-to-r
    from-transparent
    via-amber-300/45
    to-transparent
  "
/>
        {/* ===============================================
            SUBTLE BACKGROUND LIGHT
            NO BLUR = APK SAFE
        =============================================== */}

        <div
          className="
            pointer-events-none

            absolute
            inset-0

            bg-gradient-to-b

            from-white/[0.035]
            via-transparent
            to-black/10
          "
        />


        {/* ===============================================
            TABS
        =============================================== */}

        <div
          className="
            relative

            grid

            h-[62px]

            grid-cols-5

            items-center

            gap-0.5
          "
        >

         {TABS.map(
  (tab, tabIndex) => {

              const active =
                isRouteActive(
                  location.pathname,
                  tab.route
                );

              const pressed =
                pressedTab ===
                tab.key;

              const Icon =
                tab.icon;

              const label =
                t(tab.i18n) ||
                tab.fallback;


              return (

                <NavLink

                  key={
                    tab.key
                  }

                  to={
                    tab.route
                  }

                  onClick={() =>
                    handlePress(
                      tab.key
                    )
                  }

                  aria-current={
                    active
                      ? "page"
                      : undefined
                  }

                  aria-label={
                    label
                  }

                  className="
                    relative

                    flex
                    h-full

                    min-w-0

                    items-center
                    justify-center

                    rounded-[20px]
                  "
                >

                  {/* =====================================
                      ACTIVE CAPSULE
                  ===================================== */}

                  {active && (

                    <motion.div

                      layoutId="gursetu-active-tab"

                      transition={{
                        type:
                          "spring",

                        stiffness:
                          420,

                        damping:
                          34,

                        mass:
                          0.75,
                      }}

                      className="
                        absolute

                        inset-x-1
                        inset-y-1.5

                        rounded-[18px]

                        border
                        border-amber-300/15

                        bg-amber-300/[0.09]

                        shadow-[inset_0_1px_0_rgba(255,255,255,0.035)]
                      "
                    />

                  )}


                  {/* =====================================
                      TAB CONTENT
                  ===================================== */}

                  <motion.div

                    animate={{
                      y:
                        active
                          ? -1
                          : 0,

                      scale:
                        pressed
                          ? 0.92
                          : active
                            ? 1.03
                            : 1,
                    }}

                    transition={{
                      type:
                        "spring",

                      stiffness:
                        500,

                      damping:
                        28,
                    }}

                    className="
                      relative
                      z-10

                      flex
                      min-w-0

                      flex-col

                      items-center
                      justify-center

                      gap-[3px]
                    "
                  >

                    {/* ICON */}

                    <div
                      className={`
                        relative

                        grid

                        h-7
                        w-7

                        place-items-center

                        rounded-full

                        transition-colors
                        duration-200

                        ${
                          active

                            ? `
                              text-amber-400
                            `

                            : `
                              text-slate-400
                            `
                        }
                      `}
                    >

                      <Icon

                        size={
                          active
                            ? 21
                            : 20
                        }

                        strokeWidth={
                          active
                            ? 2.35
                            : 2
                        }

                      />


                      {/* ACTIVE MICRO DOT */}

                      {active && (

                        <motion.span

                          initial={{
                            opacity:
                              0,

                            scale:
                              0,
                          }}

                          animate={{
                            opacity:
                              1,

                            scale:
                              1,
                          }}

                          className="
                            absolute

                            -right-[1px]
                            -top-[1px]

                            h-[5px]
                            w-[5px]

                            rounded-full

                            bg-amber-400
                          "
                        />

                      )}

                    </div>


                    {/* LABEL */}

                    <span
                      className={`
                        max-w-[62px]

                        truncate

                        text-center

                        text-[9px]

                        leading-none

                        transition-colors
                        duration-200

                        min-[390px]:text-[9.5px]

                        ${
                          active

                            ? `
                              font-black

                              text-amber-300
                            `

                            : `
                              font-semibold

                              text-slate-400
                            `
                        }
                      `}
                    >
                      {label}
                    </span>


                    {/* =================================
                        ACTIVE BOTTOM INDICATOR
                    ================================= */}

                    <div
                      className="
                        mt-[1px]

                        h-[2px]
                        w-5

                        overflow-hidden

                        rounded-full
                      "
                    >

                      {active && (

                        <motion.div

                          layoutId="gursetu-tab-line"

                          initial={{
                            scaleX:
                              0,
                          }}

                          animate={{
                            scaleX:
                              1,
                          }}

                          className="
                            h-full
                            w-full

                            rounded-full

                            bg-gradient-to-r

                            from-amber-300
                            via-amber-400
                            to-orange-400
                          "
                        />

                      )}

                    </div>

                  </motion.div>


                  {/* =====================================
                      PRESS RIPPLE — GPU SAFE
                  ===================================== */}

                  {pressed && (

                    <motion.span

                      initial={{
                        opacity:
                          0.18,

                        scale:
                          0.7,
                      }}

                      animate={{
                        opacity:
                          0,

                        scale:
                          1,
                      }}

                      transition={{
                        duration:
                          0.22,
                      }}

                      className="
                        pointer-events-none

                        absolute

                        inset-2

                        rounded-[16px]

                        bg-amber-300/20
                      "
                    />

                  )}

                </NavLink>

              );

            }
          )}

        </div>

      </div>

    </nav>

  );
}